<template>
	<div class="page">
		<div class="screenLine">
			<div class="screenLineL">
				<div style="padding-top:20px;font-size: 20px;" @click="$router.back()">上级字典：{{detail.name}}</div>
				<!-- <el-input v-model="keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:140px;margin-right: 16px;"></el-input>
				<el-button type="warning" @click="reset">重置</el-button> -->
			</div>
			<div class="screenLineR">
				<el-button type="warning" @click="curRow={};drawerAddTwo_state=true;">新建二级字典</el-button>
				<el-button type="warning" @click="$router.back()">返回</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" height="100%">
				<el-table-column prop="no" label="序号" width="70">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="名称" width="200" >
					<template slot-scope="scope">
						{{scope.row.item_name}}
					</template>
				</el-table-column>
				<el-table-column label="编码" width="200">
					<template slot-scope="scope" >
						{{scope.row.item_code}}
					</template>
				</el-table-column>
				<el-table-column label="值" width="100">
					<template slot-scope="scope">
						{{scope.row.item_value}}
					</template>
				</el-table-column>
				<el-table-column label="参数1" >
					<template slot-scope="scope">
						<span v-if="scope.row.item_param2.length>50">{{scope.row.item_param2.substr(0,50)}} ...</span>
						<span v-else>{{scope.row.item_param2}}</span>
					</template>
				</el-table-column>
				<el-table-column label="参数2" >
					<template slot-scope="scope">
						<span v-if="scope.row.item_param2.length>50">{{scope.row.item_param2.substr(0,50)}} ...</span>
						<span v-else>{{scope.row.item_param2}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<!-- <el-button @click="see(scope.row)" type="text">查看</el-button> -->
						<el-button @click="curRow=scope.row;drawerAddTwo_state=true;" type="text">编辑</el-button>
						<el-button @click="del(scope.row)" type="text" style="color:#F41919;">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="drawerAddTwo_state">
			<drawerAddTwo :oneId="detail._id" :row="curRow" @submit="submit_drawerAddTwo"></drawerAddTwo>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import drawerAddTwo from "./drawer_addTwo.vue"
	export default {
		components:{page,drawerAddTwo},
		data() {
			return {
				detail:{},
				
				keyword:'', //关键字
				
				// 列表
				page:{
					page:1,
					pageSize:1000,
					total:0
				},
				tableData:[],
				
				// 一级字典
				drawerAddTwo_state:false,
				curRow:{},
				
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			submit_drawerAddTwo(obj){
				this.drawerAddTwo_state = false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			del(row){
				this.$confirm('确定删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:this.detail._id,
						item_id:row.item_id,
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_admin+'/api/SystemConfig/DeleteSystemDictionDetail', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 列表
			// changeSearch(){
			// 	this.page.page = 1;
			// 	this.getTableData()
			// },
			// reset(){
			// 	this.keyword = ''
				
			// 	this.page.page = 1;
			// 	this.getTableData()
			// },
			changePage(num){
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					code:this.$route.query.code
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_admin+'/api/SystemConfig/GetSystemDictionByCode', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.detail = res.data
						this.tableData = res.data.item_list||[];
						this.page.total = this.tableData.length;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px 65px 16px;height: 100%;box-sizing: border-box;position: relative;
		.screenLine{
			display: flex;justify-content: space-between;
			.screenLineL{
				
			}
			.screenLineR{
				
			}
		}
		.tableBox{
			padding:16px;border-radius: 8px;background-color: #fff;box-sizing: border-box;margin-top:16px;height: calc(100% - 56px);
		}
		
		.pagePosi{
			position: absolute;bottom:0;left:16px;right:16px;text-align:right;background-color: #fff;padding:0 10px;border-radius: 8px 8px 0 0;
		}
	}
</style>
